import React from 'react';
import PropTypes from 'prop-types';
import ReactPaginate from 'react-paginate';
import PaginationResults from './PaginationResults';

export default function MapPagination({
  totalCount,
  perPage,
  totalPages,
  onPageChange,
  currentPage,
  queryType,
}) {
  return (
    <section className="card-section-footer">
      {parseInt(totalCount) > parseInt(perPage) && (
        <ReactPaginate
          pageCount={parseInt(totalPages)}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          onPageChange={onPageChange}
          containerClassName="pagination"
          pageClassName="page"
          activeClassName="current"
          nextClassName="next"
          previousClassName="prev"
          breakClassName="page gap"
          nextLabel=""
          previousLabel=""
          forcePage={parseInt(currentPage) - 1}
        />
      )}
      <PaginationResults
        totalCount={totalCount}
        firstIndex={perPage * currentPage - perPage + 1}
        lastIndex={Math.min(perPage * currentPage, totalCount)}
        queryType={queryType}
      />
    </section>
  );
}

MapPagination.propTypes = {
  totalCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  perPage: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  totalPages: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  onPageChange: PropTypes.func.isRequired,
  currentPage: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  queryType: PropTypes.oneOf(['properties', 'listings', 'events']),
};
